import { useQuery } from "@tanstack/react-query";

import type { PortableTextBlock } from "@/api/queries";

import useAppStore from "../../../store/appStateZustand";
import client from "../client";

export type SyncItem = {
  _type: string;
  _id: string;
  name: string;
  description: PortableTextBlock | PortableTextBlock[];
  altText: string;
  imageUrl: string;
  url: string;
};

export type SyncsAvailableResult = {
  syncs_available: SyncItem[];
};

export type SyncsQueryResult = SyncItem[] | SyncsAvailableResult;

async function getSyncs(allSyncsAvailable: boolean | null): Promise<SyncsQueryResult> {
  const catalogueCode = useAppStore.getState().selectedCatalogue as string;
  const domain = window.location.origin;

  const allSyncsQuery = "*[_type == \"syncs\"]{_type, _id, name, description, \"altText\": image.altText,\"imageUrl\": image.asset->url, url}";

  const availableSyncsQuery = `*[_type == 'siteConfiguration' && ('${catalogueCode}' in catalogueConfig.catalogue_codes || '${domain}' in domainConfig.domain)][0]{'syncs_available': syncsAndOpportunities.syncsAvailable[]->{
    _type, _id, name, description, "altText": image.altText,"imageUrl": image.asset->url, url
    },
  }`;

  try {
    if (allSyncsAvailable === true) {
      return await client.fetch<SyncItem[]>(allSyncsQuery);
    }
    return await client.fetch<SyncsAvailableResult>(availableSyncsQuery);
  }
  catch (error) {
    console.error("Error fetching Syncs data:", error);
    throw error;
  }
}

function useSyncsQuery() {
  const allSyncsAvailable = useAppStore(state => state.allSyncsAvailable);

  return useQuery<SyncsQueryResult>({
    queryKey: ["syncs", allSyncsAvailable],
    queryFn: async () => getSyncs(allSyncsAvailable),
    staleTime: 120000, // 2 minutes
  });
}

export default useSyncsQuery;
